var map = {
	"./basicPersonalInfo.jsx": 6101,
	"./basicPersonalInfoForm.jsx": 96323,
	"./idUploader.jsx": 30511,
	"./identityInfo.jsx": 64277,
	"./residentialInfo.jsx": 58013,
	"./riskDisclosureContract.jsx": 60951,
	"./singleDocumentUploadForm.jsx": 34845,
	"./verificationsTable.jsx": 5447,
	"./whatIsKYC.jsx": 85410
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49856;